<script>
  import { fly } from "svelte/transition";
  let { list = [] } = $props();
</script>

<ul class="list-none list-outside">
  {#each list as { ProjectTitle, PageUrl, ShortDescription, Location }}
    <li class="mb-16 list-none pl-0" transition:fly|global={{ x: -200, duration: 2000 }}>
      <div class="mb-4">
        <a class="h4 text-river" href={PageUrl}>
          {ProjectTitle}
        </a>
      </div>  
      <p>{ShortDescription}</p>

      <span class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.17"
          height="16.669"
          viewBox="0 0 11.17 16.669"
          title="map pin">
          <g transform="translate(-140.946 -269.33)">
            <path
              d="M145.326,286c-1.79,0-5.584-8.686-5.584-11.085a5.585,5.585,0,0,1,11.17,0C150.912,277.314,147.118,286,145.326,286Zm.2-1.343h0Zm-.4,0Zm.2-13.939a4.151,4.151,0,0,0-4.2,4.2c0,2.288,3.077,8.356,4.2,9.567,1.12-1.211,4.2-7.279,4.2-9.567A4.153,4.153,0,0,0,145.326,270.718Z"
              transform="translate(1.204 0)"
              fill="#006ba6" />
            <path
              d="M144.387,276.2a2.222,2.222,0,1,1,2.223-2.222A2.224,2.224,0,0,1,144.387,276.2Zm0-3.057a.835.835,0,1,0,.835.835A.836.836,0,0,0,144.387,273.14Z"
              transform="translate(2.143 0.939)"
              fill="#0ac0dd" />
          </g>
        </svg>
        <p class="list-tag flex-initial pl-3 mb-0">{Location}</p>
      </span>
    </li>
  {/each}
</ul>
